import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import ConfirmBottomSheet from 'components/ConfirmBottomSheet';
import FloatingMenu from 'components/FloatingMenu';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { openURL } from 'utils/webViewUtils';

type Props = {
  defaultOpen?: boolean;
};

const ChannelsFloatingMenu = ({ defaultOpen }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();

  const handlePhoneButtonClick = () => openURL(`tel:+${t('customerSupport.contact.phoneNumber')}`);
  const handleChatButtonClick = () => setShowWhatsappConfirm(true);
  const handleMailButtonClick = () => history.push('/customerSupport/mail');

  const ChannelOptions = [
    {
      label: t('customerSupport.channels.phone'),
      icon: 'phone-white',
      onClick: handlePhoneButtonClick,
    },
    {
      label: 'WhatsApp',
      icon: 'whatsapp-white',
      onClick: handleChatButtonClick,
    },
    {
      label: t('customerSupport.channels.mail'),
      icon: 'mail-white',
      onClick: handleMailButtonClick,
    },
  ];

  const [showWhatsappConfirm, setShowWhatsappConfirm] = useState(false);

  const handleChatCancel = () => setShowWhatsappConfirm(false);
  const handleChatConfirm = () => {
    openURL(`https://wa.me/${t('customerSupport.contact.whatsappNumber')}?text=`);
    setShowWhatsappConfirm(false);
  };

  return (
    <div>
      <FloatingMenu
        icon="help-white"
        label={t('customerSupport.faq.title')}
        items={ChannelOptions}
        defaultOpen={defaultOpen}
      />

      <ConfirmBottomSheet
        show={showWhatsappConfirm}
        onClose={handleChatCancel}
        onConfirm={handleChatConfirm}
        title={t('customerSupport.contact.whatsappConfirm')}
      />
    </div>
  );
};

export default ChannelsFloatingMenu;
